var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 13.5L10.125 9H5.625L8.625 4.5M16.5 9.75V8.25M10.5 13.5H10.65C11.9101 13.5 12.5402 13.5 13.0215 13.2548C13.4448 13.039 13.789 12.6948 14.0048 12.2715C14.25 11.7902 14.25 11.1601 14.25 9.9V7.5C14.25 6.80252 14.25 6.45378 14.1733 6.16766C13.9653 5.3912 13.3588 4.78472 12.5823 4.57667C12.2962 4.5 11.9475 4.5 11.25 4.5M5.25 4.5H5.1C3.83988 4.5 3.20982 4.5 2.72852 4.74524C2.30516 4.96095 1.96095 5.30516 1.74524 5.72852C1.5 6.20982 1.5 6.83988 1.5 8.1V10.5C1.5 11.1975 1.5 11.5462 1.57667 11.8323C1.78472 12.6088 2.3912 13.2153 3.16766 13.4233C3.45378 13.5 3.80252 13.5 4.5 13.5",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvCharge);
export default __webpack_public_path__ + "static/media/ev-charge.f7c326da6b71f0e14813a4b6fb182910.svg";
export { ForwardRef as ReactComponent };